import { getTenCosConfig } from '@/api/system/upload.js'

// 换脸素材单独使用
// 写死子应用ID（你需要替换成你控制台里的真实 SubAppId 值）
const SUB_APP_VIDEO = 1500043016  // 视频子应用
const SUB_APP_IMAGE = 1500043016  // 图片子应用

export default class UploadFileToVOD {
  constructor(files, json) {
    if (!Array.isArray(files)) {
      throw new Error('Class UploadFileToOSS parameter must be an array');
    }

    this.data = [];
    this.fn = json.success;
    this.complete = json.finally;
    this.vProgress = json.vProgress;
    this.fileId = json.fileId;
    this.files = files;
    this.fileLen = this.files.length;
    this.curIndex = 0;

    // 根据文件类型自动选择子应用ID
    const file = this.files[0];
    if (file.type.startsWith('image/')) {
      console.log("图片图片")
      this.subAppId = SUB_APP_IMAGE;
    } else if (file.type.startsWith('video/')) {
      console.log("视频视频")
      this.subAppId = SUB_APP_VIDEO;
    } else {
      // 默认归为视频类，避免异常
      this.subAppId = SUB_APP_VIDEO;
    }

    this.upload();
  }

  upload() {
    
    const tcVod = new TcVod.default({
      getSignature: () => getTenCosConfig(this.subAppId),
      dynamicAccelerate: true,
    });

    const uploader = tcVod.upload({
      mediaFile: this.files[0],
    });

    let that = this;
    uploader.on('media_progress', function (info) {
      if (that.vProgress) that.vProgress(info.percent);
    });

    uploader.done().then(function (doneResult) {
      that.data.push(doneResult.video.url);
      if (that.fn) that.fn(that.data);
      if (that.fileId) that.fileId(doneResult.fileId);
    }).catch(function (err) {
      console.error('上传失败', err);
    });
  }
}

// import {getTenCosConfig} from '@/api/system/upload.js'

// export default class UploadFileToVOD {
//   constructor(files, json) {
//     if (!Array.isArray(files)) {
//       throw new Error('Class UploadFileToOSS parameter must be an array');
//     }
//     console.log('files, json', files, json)
//     this.data = [];
//     this.fn = json.success;
//     this.complete = json.finally;
//     this.vProgress = json.vProgress;
//     this.fileId = json.fileId;
//     this.files = files;
//     this.fileLen = this.files.length;
//     this.curIndex = 0;
//     // notification.info({ message: '上传中' })
//     this.upload();
//   }


//   upload() {
//     console.log(getTenCosConfig())
//     const tcVod = new TcVod.default({
//       getSignature: getTenCosConfig, // 签名数据
//       dynamicAccelerate: true, // 开启动态加速
//     })

//     const uploader = tcVod.upload({
//       mediaFile: this.files[0], // 媒体文件（视频或音频或图片），类型为 File
//       // fileParallelLimit:10,
//       // chunkParallelLimit:10,
//       // dynamicAccelerate:true
//     })
//     let that = this;
//     uploader.on('media_progress', function (info) {
//       // this.vProgress = info.percent
//       if (that.vProgress) that.vProgress(info.percent)
//     })

//     uploader.done().then(function (doneResult) {
//       that.data.push(doneResult.video.url)

//       console.log(22222222222)
//       console.log(doneResult)
//       console.log(doneResult.fileId)
//       // that.complete(that.data);
//       if (that.fn) that.fn(that.data)
//       if (that.fileId) that.fileId(doneResult.fileId)
//       // deal with doneResult
//     }).catch(function (err) {
//       // deal with error
//     })


//   }
// }
// import { getTenCosConfig } from '@/api/system/upload.js'

// export default class UploadFileToVOD {
//   constructor(files, options) {
//     if (!Array.isArray(files)) {
//       throw new Error('UploadFileToVOD 参数必须是文件数组');
//     }

//     this.files = files;
//     this.options = {
//       success: options.success || null,
//       finally: options.finally || null,
//       vProgress: options.vProgress || null,
//       fileId: options.fileId || null
//     };

//     // 上传状态跟踪
//     this.results = {
//       success: [],
//       failed: []
//     };

//     // 进度管理
//     this.progressMap = new Map();
//     this.totalProgress = 0;

//     this.startUpload();
//   }

//   async startUpload() {
//     try {
//       await this.initializeTcVod();
//       await this.processUploads();
//     } catch (error) {
//       console.error('上传初始化失败:', error);
//       this.results.failed.push(...this.files.map(file => ({
//         file,
//         error: error.message
//       })));
//     } finally {
//       this.handleCompletion();
//     }
//   }

//   async initializeTcVod() {
//     // 获取最新签名配置
//     const signatureConfig = await getTenCosConfig();
    
//     this.tcVod = new TcVod.default({
//       getSignature: () => signatureConfig,
//       dynamicAccelerate: true,
//       retryTimes: 3,  // 增加重试机制
//       chunkRetryTimes: 2
//     });
//   }

//   async processUploads() {
//     const uploadPromises = this.files.map((file, index) => 
//       this.uploadSingleFile(file, index)
//     );

//     await Promise.allSettled(uploadPromises);
//   }

//   uploadSingleFile(file, index) {
//     return new Promise(async (resolve, reject) => {
//       try {
//         const uploader = this.tcVod.upload({
//           mediaFile: file,
//           enableResume: true  // 启用断点续传
//         });

//         // 配置进度监听
//         this.configureProgressListener(uploader, file, index);
        
//         // 执行上传
//         const result = await uploader.done();
//         this.handleSuccess(file, result);
//         resolve();
//       } catch (error) {
//         this.handleError(file, error);
//         reject(error);
//       }
//     });
//   }

//   configureProgressListener(uploader, file, index) {
//     uploader.on('media_progress', (progress) => {
//       this.progressMap.set(file.name, progress.percent);
//       this.calculateTotalProgress();
      
//       this.options.vProgress?.({
//         file,
//         index,
//         percent: progress.percent,
//         total: this.totalProgress
//       });
//     });
//   }

//   calculateTotalProgress() {
//     const progresses = Array.from(this.progressMap.values());
//     this.totalProgress = progresses.length > 0 
//       ? progresses.reduce((a, b) => a + b) / progresses.length
//       : 0;
//   }

//   handleSuccess(file, result) {
//     const successData = {
//       file,
//       url: result.video.url,
//       fileId: result.fileId,
//       coverUrl: result.cover?.url,
//       duration: result.video.duration
//     };

//     this.results.success.push(successData);
//     this.options.fileId?.(result.fileId);
//   }

//   handleError(file, error) {
//     const errorInfo = {
//       file,
//       error: error.message,
//       code: error.code || 'UNKNOWN_ERROR'
//     };

//     this.results.failed.push(errorInfo);
//     console.error(`文件上传失败 [${file.name}]:`, error);
//   }

//   handleCompletion() {
//     this.options.finally?.(this.results);
    
//     if (this.results.success.length > 0) {
//       this.options.success?.(this.results.success);
//     }
//   }
// }